export default function EABusinessClimate() {
    return <iframe
        title="Деловой климат"
        className="w-full"
        height={window.innerHeight - (window.innerHeight * 0.1)}
        src="https://invest.eoz.kz/dashboard-public/"
        frameBorder="0"
        allowFullScreen="true"
    />
}